export default __webpack_public_path__ + "static/media/implies.f8943015.png";